export default "__VITE_PUBLIC_ASSET__81bfd3a5__"